import React from 'react'
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { SortableContainer } from 'react-sortable-hoc';
import SortableItem from './SortableItem'
import getObjectValue from 'libs/getObjectValue';

const style = theme => ({
	root: {

	}
})

const SortableList = SortableContainer(({
	classes,
	formikProps,
	id,
	children
}) => {
	const elements = getObjectValue(id, formikProps.values)

	return (
		<div>
			{elements.map((item, i) => (
				<SortableItem
					children={children}
					key={i}
					formikProps={formikProps}
					i={i}
					index={i}
					id={id}
				/>
			))}
		</div>
	)
})

SortableList.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(SortableList);